import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CoreModule } from '../../core/core.module';
import { AuthComponent } from './auth.component';
import { EmailLoginComponent, EmailRegistrationComponent, MobileLoginComponent, MobileRegistrationComponent, ForgotPasswordComponent, LogRegistrationComponent } from './components';
import { NgOtpInputModule } from 'ng-otp-input';
@NgModule({
  declarations: [
    AuthComponent,
    LogRegistrationComponent,
    EmailLoginComponent,
    EmailRegistrationComponent,
    MobileLoginComponent,
    MobileRegistrationComponent,
    ForgotPasswordComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    CoreModule,
    NgOtpInputModule
    
  ],
  exports: [
    AuthComponent,
    LogRegistrationComponent,
    EmailLoginComponent,
    EmailRegistrationComponent,
    MobileLoginComponent,
    MobileRegistrationComponent,
    ForgotPasswordComponent,
  ]
})
export class AuthModule { }
